import styled from 'styled-components'

const Box = styled.div`
  padding: 20px 40px 40px 40px;
`

export const s = { Box }
